import {useGTMDispatch} from './react-gtm-hook/index'
import {
  transformSalesforceBasketItemsForGA4,
  transformAlgoliaItemsForBasketEventsGA4
} from './utils'
import { useRapidDeliveryStore } from '../store/hooks/useStore'

export const useAddToCartTracking = (basket) => {
  const sendDataToGTM = useGTMDispatch()
  const {isRapidDeliveryBooked} = useRapidDeliveryStore()
  const sendAddToCartData = (addToCartData) => {
    const { product, cartLocation, viewingCategoryId, searchQuery, hitItemIndex } = addToCartData
    setTimeout(() => {
      try {
        const transformAlgoliaData = {
          items: [product],
          cartLocation,
          viewingCategoryId,
          searchQuery,
          hitItemIndex,
          isRapidDeliveryBooked
        }
        const _items = transformAlgoliaItemsForBasketEventsGA4(transformAlgoliaData)
        const eventData = {
          event: 'add_to_cart',
          ecommerce: {
            currency: 'GBP',
            value: _items[0].price * _items[0].quantity,
            cart_location: cartLocation,
            coupon: basket?.couponItems?.[0]?.code ?? '',
            items: _items
          },
        }
        sendDataToGTM(eventData)
      } catch (error) {
        console.error('useAddToCartTracking error within setTimeout: ' + error.message)
      }
    }, 0)
  }
  return sendAddToCartData
}

export const useRemoveFromCartTracking = () => {
  const sendDataToGTM = useGTMDispatch()
  const {isRapidDeliveryBooked} = useRapidDeliveryStore()
  const sendRemoveFromCartData = (removeFromCartObject) => {
    const { product, cartLocation, viewingCategoryId, searchQuery, hitItemIndex } = removeFromCartObject
    setTimeout(() => {
      try {
        const transformAlgoliaData = {
          items: [product],
          cartLocation,
          viewingCategoryId,
          searchQuery,
          hitItemIndex,
          isRapidDeliveryBooked
        }
        const _items = transformAlgoliaItemsForBasketEventsGA4(transformAlgoliaData)
        const eventData = {
          event: 'remove_from_cart',
          ecommerce: {
            currency: 'GBP',
            value: _items[0].price * _items[0].quantity,
            cart_location: cartLocation,
            items: _items
          },
        }
        sendDataToGTM(eventData)
      } catch (error) {
        console.error('useRemoveFromCartTracking error within setTimeout: ' + error.message)
      }
    }, 0)
  }
  return sendRemoveFromCartData
}

export const useBeginCheckoutTracking = (productsById) => {
  const sendDataToGTM = useGTMDispatch()
  const sendBeginCheckout = (basket, items) => {
    if (!basket || !items) return
    setTimeout(() => {
      try {
        const itemsData = transformSalesforceBasketItemsForGA4(items, productsById)
        const eventData = {
          event: 'begin_checkout',
          ecommerce: {
            transaction_id: basket.basketId,
            currency: 'GBP',
            value: basket.orderTotal,
            coupon: basket.couponItems?.[0]?.code ?? '',
            items: itemsData,
          },
        }
        if (Object.keys(eventData.ecommerce.items).length > 0) {
          sendDataToGTM(eventData)
        }
      } catch (error) {
        console.error('useBeginCheckoutTracking error within the setTimeout: ' + error.message)
      }
    }, 0)
  }
  return sendBeginCheckout
}
